import axios from 'axios'
import VueCookies from 'vue-cookies'

export default {
  get (data) {
    // limit
    const limit = data.limit ? '&limit=' + data.limit : ''
    // search
    const search = data.search ? '&s=' + data.search + '&s_field=name' : ''
    // pagination
    const page = data.page ? '&page=' + data.page : '&page=1'
    return axios.get(process.env.API_ENDPOINT + '/student?token=' + VueCookies.get('token') + page + search + limit)
  },
  delete (id) {
    return axios.delete(process.env.API_ENDPOINT + '/student/' + id + '?token=' + VueCookies.get('token'))
  },
  getStudentFromClassType (id) {
    return axios.get(process.env.API_ENDPOINT + '/student?token=' + VueCookies.get('token') + '&class_type_id=' + id)
  },
  getStudentPerClient (id) {
    return axios.get(process.env.API_ENDPOINT + '/student/client/' + id + '?token=' + VueCookies.get('token'))
  },
  getStudentsPerTeacher (id) {
    return axios.get(process.env.API_ENDPOINT + '/teacher/students/' + id + '?token=' + VueCookies.get('token'))
  }
}



// WEBPACK FOOTER //
// ./src/store/api/students.js